import React from 'react';
import { useTranslation } from 'react-i18next';
import './HeroSection.css';

/**
 * HeroSection - Full-width banner with LOVWhereYouWork graphic
 *
 * Uses the official banner image with team collaboration background
 * Features empowering imagery showing diverse professionals
 * Shows Spanish version when language is set to Spanish
 */
export function HeroSection() {
  const { t, i18n } = useTranslation();

  // Use Spanish header image when language is Spanish
  const headerImage = i18n.language === 'es'
    ? '/Lovewhere youworkAITool_Websiteheader_spanish subheadline.jpg'
    : '/Lovewhere youworkAITool_Websiteheader.jpg';

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Banner Image */}
        <div className="hero-banner-wrapper">
          <img
            src={headerImage}
            alt={t('hero.imageAlt')}
            className="hero-banner-image"
          />
        </div>
      </div>
    </section>
  );
}
